import { isValidPhoneNumber as isValid, CountryCode } from 'libphonenumber-js';

export default class ValidationHelper {
    /**
     * Determine if phone number is a valid phone number.
     * @param phoneNumber 
     * @returns boolean
     */
    public static isValidPhoneNumber = (phoneNumber : string, defaultCountry : CountryCode = 'ZA') : boolean => {
        if (phoneNumber.trim() === '') return false;

        return isValid(phoneNumber, defaultCountry);
    }

    /**
     * Determine if fax number is a valid fax number.
     * @param faxNumber 
     * @returns boolean
     */
    public static isValidFaxNumber = (faxNumber : string) : boolean => {
        if (faxNumber.trim() === '') return false;

        return /^\+?[0-9]{6,}$/.test(faxNumber);
    }
}